function groupCmp(x, y) {
  if (x[2].innerHTML === y[2].innerHTML) {
    const numX = Number(x[0].innerHTML);
    const numY = Number(y[0].innerHTML);
    return numX > numY;
  } else {
    let numX = x[2].innerHTML;
    if (numX === " ") numX = "E";
    let numY = y[2].innerHTML;
    if (numY === " ") numY = "E";
    return numX > numY;
  }
}

function groupSorter() {
  var table,
    rows,
    switching,
    i,
    x,
    y,
    shouldSwitch,
    dir,
    switchcount = 0;
  table = document.getElementById("Table");
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc";
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    rows = table.rows;
    /* Loop through all table rows (except the
    first, which contains table headers): */
    for (i = 2; i < rows.length - 2; i += 2) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Get the two elements you want to compare,
      one from current row and one from the next: */
      x = rows[i].getElementsByTagName("TD");
      y = rows[i + 2].getElementsByTagName("TD");
      /* Check if the two rows should switch place,
      based on the direction, asc or desc: */
      if (dir === "asc") {
        if (groupCmp(x, y)) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      } else if (dir === "desc") {
        if (groupCmp(y, x)) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      rows[i].parentNode.insertBefore(rows[i + 2], rows[i]);
      rows[i + 1].parentNode.insertBefore(rows[i + 3], rows[i + 1]);
      switching = true;
      // Each time a switch is done, increase this count by 1:
      switchcount++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount === 0 && dir === "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

function probCmp(x, y) {
  const numX = x === "&gt;99.9" ? 100 : x === "&lt;0.1" ? 0 : Number(x);
  const numY = y === "&gt;99.9" ? 100 : y === "&lt;0.1" ? 0 : Number(y);
  return numX < numY;
}

function groupToNum(x) {
  return x==="" ? 100 : (x[0].charCodeAt(0) - 64);
}

function probSorter(id, mustAsc = false) {
  var table,
    rows,
    switching,
    i,
    x,
    y,
    shouldSwitch,
    dir,
    switchcount = 0;
  table = document.getElementById("Table");
  if (table === null) return;
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc";
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    rows = table.rows;
    /* Loop through all table rows (except the
    first, which contains table headers): */
    for (i = 2; i < rows.length - 2; i += 2) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Get the two elements you want to compare,
      one from current row and one from the next: */
      x = rows[i].querySelector("#" + id);
      if (x === null) return;
      y = rows[i + 2].querySelector("#" + id);
      x = x.innerHTML.split("%")[0];
      y = y.innerHTML.split("%")[0];
      if (id === "rank") {
        x = -x;
        y = -y;
      }
      if(id === "group"){
        x = -groupToNum(x)
        y = -groupToNum(y)
      }
      /* Check if the two rows should switch place,
      based on the direction, asc or desc: */
      if (dir === "asc") {
        if (probCmp(x, y)) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      } else if (dir === "desc") {
        if (probCmp(y, x)) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      rows[i].parentNode.insertBefore(rows[i + 2], rows[i]);
      rows[i + 1].parentNode.insertBefore(rows[i + 3], rows[i + 1]);
      switching = true;
      // Each time a switch is done, increase this count by 1:
      switchcount++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount === 0 && dir === "asc") {
        if (mustAsc) return;
        dir = "desc";
        switching = true;
      }
    }
  }
}

export { groupSorter, probSorter };
